module.exports = Jsw.skinUrl + "/images/sticker-collection/burst/lightning_01.png?413b7dd607e2de663176c2fef342f4c5";